export const en = {
    apply: 'Use',
    create: 'create',
    'create-from-preset': 'Use as template',
    'creative-remove-confirm-description': 'Do you really want to delete the set of banners?',
    edit: 'Edit',
    'no-creatives': 'No creatives',
    'no-creatives-but-can-create': "You don't have any creatives yet — go ahead and {presetsLink}",
    select: 'Select',
    selected: '{selected} of {total} selected',
    'selected-banner-sizes': 'Showing creatives with banner sizes: {sizes} ',
    view: 'View'
};
